<mat-card class="shadow-none p-8 m-b-0 p-b-0">
  <mat-card-title class="title m-b-8">
    <span>{{ title | translate }}</span>
    <span (click)="closeDialog()">
      <i-tabler name="x" class="icon-20 w-8 d-flex rounded cursor-pointer aspect-square hover:bg-[var(--mat-color-light-table-hover)] hover:text-[var(--mat-sys-primary)] dark:hover:bg-[var(--striped-row-background-color)] dark:hover:text-[var(--mat-color-primary)]"/>
    </span>
  </mat-card-title>
  <mat-card-content class="p-0!">
    <app-dynamic-form
      #systemUserForm
      [formConfigs]="userFormConfig"
      [formGroup]="userForm"
      [spinLoader]="spinLoader"
      [onSubmit]="addOrUpdateUserAdmin">
    </app-dynamic-form>
  </mat-card-content>
</mat-card>
